<!--
 * @Description: 请输入当前文件描述
 * @Author: ChangWenBo (649160016@qq.com)
 * @Date: 2021-03-29 14:24:11
 * @LastEditors: ChangWenBo (649160016@qq.com)
 * @LastEditTime: 2021-04-20 11:30:21
 -->
<template>
  <div class="passengerCount">
    <div class="titleHeader">
      <img src="/static/img/layout/arrow-orange.png" alt="">
      <span class="titleName">客户数量统计</span>
    </div>
    <div class="passengersCharts" ref="passengersCharts"></div>
  </div>
</template>

<script>
export default {
  name: 'passengerCount',
  components: {
  },
  data () {
    return {
      charts: '',
      xAxis: [],
      yPassengerAxis: [],
      yGrowthAxis: [],
    }
  },
  methods: {
    /**
     * @description                   初始化图表
     * @return {undefied}             无返回值
     */
    initCharts () {
      this.charts = this.$echarts.init(this.$refs.passengersCharts)
      let options = {
        tooltip: {
          trigger: 'axis',
          axisPointer: {
            type: 'cross',
            crossStyle: {
              color: '#999',
            },
          },
        },
        legend: {
          textStyle: {
            color: '#fff',
          },
          data: ['客户数量', '增长率'],
        },
        xAxis: {
          type: 'category',
          data: this.xAxis,
          nameTextStyle: {
            color: '#fff',
          },
          axisLine: {
            show: true,
            lineStyle: {
              color: '#32444B',
            },
          },
          splitLine: {
            show: false,
            lineStyle: {
              color: '#32444B',
              type: 'dashed',
            },
          },
          axisLabel: {
            textStyle: {
              color: '#fff',
            },
          },
        },
        yAxis: [
          {
            type: 'value',
            name: '客户数量（人）',
            position: 'left',
            nameTextStyle: {
              color: '#fff',
            },
            axisLine: {
              show: true,
              lineStyle: {
                color: '#32444B',
              },
            },
            splitLine: {
              show: true,
              lineStyle: {
                color: '#32444B',
                type: 'dashed',
              },
            },
            axisLabel: {
              textStyle: {
                color: '#fff',
              },
            },
          },
          {
            type: 'value',
            name: '增长率（%）',
            position: 'right',
            nameTextStyle: {
              color: '#fff',
            },
            axisLine: {
              show: true,
              lineStyle: {
                color: '#32444B',
              },
            },
            splitLine: {
              show: true,
              lineStyle: {
                color: '#32444B',
                type: 'dashed',
              },
            },
            axisLabel: {
              textStyle: {
                color: '#fff',
              },
            },
          },
        ],
        series: [
          {
            name: '客户数量',
            type: 'bar',
            itemStyle: {
              color: new this.$echarts.graphic.LinearGradient(0, 0, 0, 1, [{
                offset: 0,
                color: 'rgba(3,247,247,0.9)',
              }, {
                offset: 0.3,
                color: 'rgba(3,247,247,0.9)',
              }, {
                offset: 1,
                color: 'rgba(20,51,56,0.9)',
              }]),
              borderRadius: [4, 4, 0, 0],
            },
            barWidth: 7,
            yAxisIndex: 0,
            data: this.yPassengerAxis,
          },
          {
            name: '增长率',
            data: this.yGrowthAxis,
            type: 'line',
            color: '#eceb50',
            symbol: 'circle',
            symbolSize: 8,
            yAxisIndex: 1,
            lineStyle: {
              color: '#eceb50',
            },
          },
        ],
      }
      this.charts.setOption(options)
      window.onresize = () => {
        this.charts.resize()
      }
    },
    /**
     * @description                   获取数据
     * @return {undefied}             无返回值
     */
    getData () {
      this.$http.get('/rest/screen/home/customer/summary')
        .then(res => {
          if (res.code === 0) {
            let xAxis = []
            let yPassengerAxis = []
            let yGrowthAxis = []
            res.data.map(k => {
              xAxis.push(k.year)
              yPassengerAxis.push(k.number)
              yGrowthAxis.push(k.rate)
            })
            this.xAxis = xAxis
            this.yPassengerAxis = yPassengerAxis
            this.yGrowthAxis = yGrowthAxis
            this.initCharts()
          } else {
            this.$message({
              message: res.msg,
              type: 'error',
            })
          }
        })
    },
  },
  mounted () {
    this.getData()
  },
  created () {
  },
}
</script>

<style lang="less" scoped>
  .passengerCount {
    width: 100%;
    height: 100%;
    font-size: 20px;
    .titleHeader {
      width: 100%;
      height: 40px;
      background: url('/static/img/layout/titleHeaderBg.png');
      background-size: 100% 100%;
      >img {
        height: 100%;
        margin-right: 20px;
        vertical-align: middle;
      }
      .titleName {
        vertical-align: middle;
        display: inline-block;
        color: #05dbe3;
        height: 40px;
        line-height: 40px;
      }
    }
    .passengersCharts {
      width: 100%;
      height: calc(100% - 40px);
    }
  }
</style>
